module.exports = __webpack_public_path__ + "static/media/dot_1AC4AD.fa75e204.svg";